"use client";

export default function BetaBadge({ className = "" }) {
  return (
    <div
      className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none z-[1001] ${className}`}
      title="This widget is in beta testing"
      style={{
        display: "inline-flex",
        padding: "5px 12px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div
        className="text-white text-xs font-semibold tracking-wide"
        style={{
          borderRadius: "30px",
          border: "1px solid #FFF3CE",
          background:
            "var(--Gold-Temp, linear-gradient(135deg, #E1C87E 0%, #A17A16 100%))",
          padding: "5px 12px",
          justifyContent: "center",
          alignItems: "center",
          display: "inline-flex",
          gap: "10px",
        }}
      >
        BETA
      </div>
    </div>
  );
}
